// @flow

/**
 * Convert underscored separated string to sentence.
 * @param value underscored separated string
 * @returns {string|?string} sentence or null if value is null
 */
export const toSentence = (value: ?string): ?string => {
  if (value) {
    const parts = value.trim().split('_');
    let sentence = '';
    for (let part of parts) {
      if (!sentence) {
        sentence = part.substring(0, 1).toUpperCase() + part.substring(1).toLowerCase();
      } else {
        sentence += ' ' + part.toLowerCase();
      }
    }
    return sentence;
  }
  return value;
};

/**
 * Convert camel-cased string to sentence.
 * @param value camel-cased string
 * @returns {string|?string} sentence or null if value is null
 */
export const camelCaseToSentence = (value: ?string): ?string => {
  if (value) {
    const parts = value.trim().split(/(?=[A-Z])/);
    let sentence = '';
    for (let part of parts) {
      if (!sentence) {
        sentence = part.substring(0, 1).toUpperCase() + part.substring(1).toLowerCase();
      } else {
        sentence += ' ' + part.toLowerCase();
      }
    }
    return sentence;
  }
  return value;
};
